module.exports = __webpack_public_path__ + "static/media/report-kids-smiling.9c8fb4db.jpg";